/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Cases_By_Step_TitleInputs */

const en_dashboard_cases_by_step_title = /** @type {(inputs: Dashboard_Cases_By_Step_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases by step`)
};

const pt_br2_dashboard_cases_by_step_title = /** @type {(inputs: Dashboard_Cases_By_Step_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos por etapa`)
};

/**
* | output |
* | --- |
* | "Cases by step" |
*
* @param {Dashboard_Cases_By_Step_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_cases_by_step_title = /** @type {((inputs?: Dashboard_Cases_By_Step_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Cases_By_Step_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_cases_by_step_title(inputs)
	return pt_br2_dashboard_cases_by_step_title(inputs)
});